import "react-datetime/css/react-datetime.css";

import React, { Component } from "react";

import Datetime from "react-datetime";
import moment from "moment";

export class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.handleCalendarChange = this.handleCalendarChange.bind(this);
  }

  show() {
    this.setState({ show: true });
  }

  hide() {
    this.setState({ show: false });
  }

  handleCalendarChange(date) {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: moment(date) !== "Invalid date" ? moment(date) : null
      }
    });
    this.hide();
  }

  render() {
    const date = this.props.value ? moment(this.props.value) : null;
    return (
      <div>
        <Datetime
          closeOnSelect={true}
          inputProps={{
            onClick: e => e.target.select()
          }}
          onChange={e => {
            if (typeof e !== "string") this.handleCalendarChange(e._d);
            // updateFormValue("expiryDate", e._d);
          }}
          onBlur={e => {
            const d = moment(e, "L", this.props.locale).toDate();
            this.handleCalendarChange(d);
            // updateFormValue("expiryDate", d);
          }}
          // onChange={this.handleCalendarChange}
          locale={this.props.locale}
          date={date}
          timeFormat={false}
          value={date}
          lang="fr"
          theme={{ DaySelected: { background: "#45a9c3" } }}
        />
        {/*<FormControl
          key="control"
          readOnly
          type="text"
          autoFocus={true}
          placeholder={this.props.placeholder}
          value={date ? date : ''}
          onClick={this.show}
          ref={field => (this.target = field)}
          style={{ backgroundColor: 'white' }}
        />
        <Overlay
          key="overlay"
          show={this.state.show}
          rootClose={true}
          onHide={this.hide}
          container={this}
          target={() => ReactDOM.findDOMNode(this.target)}
          placement="bottom">
          {popover}
        </Overlay>
        */}
      </div>
    );
  }
}
